import Axios from "axios";
import {
    SET_DOCUMENTS_FOLDER_LIST,
    UNSET_DOCUMENTS_FOLDER_LIST,
} from "@/store/mutation-types";

import { 
    saveDocumentsFolder, 
    updateDocumentFolder,
    getDocumentsFolderList,
    downloadFolder,
    deleteDocumentsFolder,
} from "@/store/api";

const state = {
    getDocumentsFolderList: [],
};

const getters = {
    getDocumentsFolderList(state) {
        return state.getDocumentsFolderList;
    },
};

const mutations = {
    [SET_DOCUMENTS_FOLDER_LIST](state, data) {
        state.getDocumentsFolderList = data;
    },
    [UNSET_DOCUMENTS_FOLDER_LIST](state) {
        state.getDocumentsFolderList = [];
    },
};

const actions = {
    saveDocumentsFolder({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveDocumentsFolder, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    updateDocumentFolder({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.put(updateDocumentFolder+`/${data.folder_id}`, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getDocumentsFolderList({ commit }, data) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", {color: "primary"});
            Axios.get(getDocumentsFolderList, { params: data})
                .then(function (response) {
                    commit('SET_DOCUMENTS_FOLDER_LIST', response.data.data)
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_DOCUMENTS_FOLDER_LIST')
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING")
                });
        });
    },

    downloadFolder({ commit }, data) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", {color: "primary"});
            Axios.get(downloadFolder + `/${data}/download`)
                .then(function (response) {
                    commit("UNSET_LOADING");
                    resolve(response);
                })
                .catch(function (error) {
                    commit("UNSET_LOADING");
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    deleteFolder({ commit }, data) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", { color: "primary" });
            
            Axios.delete(deleteDocumentsFolder + `/${data}`)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    console.error('Delete error:', error);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },

};

export default {
    state,
    getters,
    actions,
    mutations,
};
